import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs/plugin/utc";
dayjs.extend(dayjsPluginUTC);

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";

import URLCallsPermanent from "./URLCallsPermanent";
import URLRecallClients from "./URLRecallClients";

class URLCallsContainer extends React.Component {

    constructor() {
        super();
        this.state = {
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload"),
            reloadKey: 0,
            createNew: 0,
            selectedPage: "permanentcalls",
            target: strings.CallCenter
        };
    }

    componentDidMount() {
        this.props.toggleURLCallsMenu();
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            openModal: 0,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps, prevState) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }

    //#endregion
    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        return <>
            <Area
                helmet={strings.helmetURLCalls}
                title={strings.URLCalls}
                navigatedId={this.state.selectedPage}
                navigation={[
                    {
                        id: "permanentcalls",
                        title: strings.Permanent,
                        onSelect: () => this.setState(prev => ({
                            selectedPage: "permanentcalls",
                            reloadKey: prev.reloadKey + 1
                        }))
                    },
                    {
                        id: "clientrecalls",
                        title: strings.ClientsRecall,
                        onSelect: () => this.setState(prev => ({
                            selectedPage: "clientrecalls",
                            reloadKey: prev.reloadKey + 1
                        }))
                    }
                ]}
                sideButtons={
                    this.state.selectedPage === "permanentcalls" && accessrights && accessrights.hasPermission(400, "create") > 10 ? [
                        {
                            type: "primary-icon",
                            nameIcon: "add",
                            text: strings.CreateANewLink,
                            onClick: () => this.setState({ createNew: this.state.createNew + 1 })
                        }
                    ] : this.state.selectedPage === "clientrecalls" && accessrights && accessrights.hasPermission(430, "create") > 10 ? [
                        {
                            type: "primary-icon",
                            nameIcon: "add",
                            text: strings.CreateANewLink,
                            onClick: () => this.setState({ createNew: this.state.createNew + 1 })
                        }
                    ] : []
                }
            >
                <div className="container-area-body">
                    { this.state.selectedPage == "permanentcalls" ? <URLCallsPermanent
                        reload={this.state.reload}
                        key={`permanentcalls-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                    }
                    { this.state.selectedPage == "clientrecalls" ? <URLRecallClients
                        reload={this.state.reload}
                        key={`clientrecalls-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                    }
                </div>
            </Area>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(URLCallsContainer);
